import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common'
import { environment } from '../../environments/environment';
import { proposalData } from './proposal-data.model';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
@Component({
  selector: 'app-personal-accident-proposal',
  templateUrl: './personal-accident-proposal.component.html',
  styleUrls: ['./personal-accident-proposal.component.css']
})
export class PersonalAccidentProposalComponent implements OnInit {
  modalRef: BsModalRef;
  public value;
  thankyouSection: boolean = false;
  transactionFailureSection: boolean = false;
  loading: boolean;
  nomineeList: any;
  error: any;
  occupationList: any;
  occupationListMap: { 'key': string; 'value': {}; };
  listOfOccupation: any[];
  data:  {};
  f: proposalData = new proposalData();
  cityStateList: any;
  pinCodeValue: any;
  cityList: any;
  stateList: any;
  fName: any;
  lName: any;
  regDate: any;
  PAQuoteId: string;
  proposalId: any;
  errorInternalMsg: any;
  errorStatus: any;
  ageDifference: number;
  shouldBe18: boolean;
  DOBrequired: boolean;
  invalidPincode: boolean;
  mobileNumber:string;
  public environment = environment;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private router: Router, private serviceURLService: serviceURLService, private modalService: BsModalService,public datepipe: DatePipe) {
    this.value = new Date();
   }
  
  ngOnInit() {
    this.getNomineeList();
    this.getOccupationList();
    this.getAutopopulatedData();    
  }

  getAutopopulatedData(){
    setTimeout(() => {
      this.f.firstName = localStorage.getItem("name").split(" ")[0];
      this.f.lastName = localStorage.getItem("name").split(" ").slice(-2).join(' ');
      this.f.mobile = localStorage.getItem("mobileNumber");
      this.f.email = localStorage.getItem("email")
    }, 500);    
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) ) {
      event.preventDefault();
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false});
  }

  

  getNomineeList() {
    this.serviceURLService.getNomineeList().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.nomineeList = successData.data.nomineeList;
    }, errorData => {
      console.log("Oops..!! nominee list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  getOccupationList() {
    this.serviceURLService.getOccupationList().pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      var occupationList = Object.values(successData.data.occupation)
      
      let newOccupationList=[];

      for (let i=0;i<(occupationList).length;i++){
        this.occupationListMap = {
          'key' : Object.keys(successData.data.occupation)[i],
          'value' : Object.values(successData.data.occupation)[i]
        }
        newOccupationList.push(this.occupationListMap)
      }

      this.listOfOccupation = newOccupationList;
    }, errorData => {
      console.log("Oops..!! nominee list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  getCityStateList(pinCode) {
    this.f.pincode = pinCode;
    this.loading = true;
    this.data = {
      "pincode":JSON.stringify(this.f.pincode)
    }
    this.serviceURLService.getCityStateList(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.cityStateList = successData.data;
      // this.cityList = successData.data.cityList;
      // this.f.state = successData.data.state;
      var cityName = successData.data.cityList[0];
      this.cityList = cityName[0].toUpperCase() + cityName.slice(1);
      var stateName = successData.data.state;
      this.f.state = stateName[0].toUpperCase() + stateName.slice(1);
      this.loading = false;

      if(this.cityList.length == 0){
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.invalidPincode = true;
      }
      else{
        this.invalidPincode = false;
      }
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  getProposalService(f){
    this.loading = true;
    this.f.prospectId = localStorage.getItem("prospectIdPA");
    this.f.quoteId = localStorage.getItem("PAQuoteId");
    this.f.sumInsured = localStorage.getItem("sumInsured");
    this.f.premium = localStorage.getItem("religarePremium");
    this.f.dob = this.datepipe.transform(this.f.dob, 'dd/MM/yyyy');
    this.f.pincode = JSON.stringify(this.f.pincode)
    
    this.data = {
      firstName: this.f.firstName,
      lastName: this.f.lastName,
      mobile: this.f.mobile,
      email: this.f.email,
      sumInsured: this.f.sumInsured,
      title: this.f.title,
      address: [this.f.address1, ''],
         
      dob: this.f.dob,
      // adhaar : string = '';
      pincode:this.f.pincode,
      city: this.f.city,
      state: this.f.state,
      occupation: this.f.occupation,
      nomineeName: this.f.nomineeName,
      nomineeRelation: this.f.nomineeRelation,
      prospectId: this.f.prospectId,
      quoteId: this.f.quoteId,
      premium: this.f.premium
    }

    this.serviceURLService.getProposalService(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      
      if(successData.isSuccess == true){
        this.proposalId = successData.data.proposalId;
        
      }else{
        
        this.transactionFailureSection = true;
        this.errorInternalMsg = successData.internalMessage
        
      }
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  acceptTandC(){
    // this.thankyouSection = true;
    this.loading = true;
    this.data = {
      "proposalId":this.proposalId,
      "returnUrl":"/api/notify/personal-accident/v1/getTransactionResponse"
    }
    this.serviceURLService.getTransactionURL(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.loading = false;
      // console.log("successData ",successData)
      if(successData.data){
        let status = successData.data.isSuccess
        if(status == true){
          let transactionUrl = successData.data.transactionUrl
          window.location.href = transactionUrl;
          
        }else{
          this.transactionFailureSection = true;
        }
      }else{
        this.errorStatus = successData.error;
        this.errorInternalMsg = successData.internalMessage;
        this.transactionFailureSection = true;
      }
      //window.location.href = "/transaction-response/personal-accident-religare";
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  calculateAge() { 
    this.DOBrequired = false;
    var regesterDate = new Date(this.f.dob);
    var ageDifMs = Date.now() - regesterDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    this.ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
      if(this.ageDifference < 18){
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        proceedButton.disabled = true;
        this.shouldBe18= true;
      }else{
        var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        this.shouldBe18= false;
      }
    
  }

  checkValue(){
    if(!this.f.dob){
      this.DOBrequired= true;
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
